export const update = {
  updateSuccessfully: '水洗機部品の変更に成功しました。',
  updateFailed: '水洗機部品の変更に失敗しました。',
}
